import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import { requiresLogin } from 'project/utils';
import { showWinnerBanner } from 'entries/utils';
import { withRouter } from 'react-router';
import Brief from 'project/components/brief';

const mapStateToProps = state => {
  const project = getProject(state);
  return {
    user: state.user.profile_data,
    loginRequired: requiresLogin(state),
    showWinnerBanner: showWinnerBanner({ project }),
    project,
  };
};

export default withRouter(connect(mapStateToProps)(Brief));



// WEBPACK FOOTER //
// ./project/containers/brief.jsx